import React, { Fragment } from 'react';

const AdminEditSelectChoice = (props) => {

    function handleClick(event) {
        props.onMessage(event)
    }

    return (
        <Fragment>
            <div className="bg-white rounded-xl shadow-md border border-neutral-200 overflow-hidden">
                <div className="px-4 sm:px-6 py-4 border-b border-neutral-200">
                    <h2 className="text-lg font-semibold text-neutral-800">Please select one of the following to edit:</h2>
                    <div className="w-12 h-1 bg-blue-500 rounded mt-2"></div>
                </div>
                <div className="p-4 sm:p-6 flex flex-wrap gap-3">
                    <button
                        className="bg-neutral-100 hover:bg-neutral-200 text-neutral-700 font-medium py-2 px-4 rounded-lg border border-neutral-300 transition-colors"
                        onClick={() => handleClick('Details')}
                    >
                        Edit Date/Time or other details
                    </button>
                    <button
                        className="bg-neutral-100 hover:bg-neutral-200 text-neutral-700 font-medium py-2 px-4 rounded-lg border border-neutral-300 transition-colors"
                        onClick={() => handleClick('Status')}
                    >
                        Change Status from {props.searchStatus}
                    </button>
                    <button
                        className="bg-neutral-100 hover:bg-neutral-200 text-neutral-700 font-medium py-2 px-4 rounded-lg border border-neutral-300 transition-colors"
                        onClick={() => handleClick('Notary')}
                    >
                        Change Assigned Agent
                    </button>
                    <button
                        className="bg-neutral-100 hover:bg-neutral-200 text-neutral-700 font-medium py-2 px-4 rounded-lg border border-neutral-300 transition-colors"
                        onClick={() => handleClick('DirectAssign')}
                    >
                        Directly Assign Agent
                    </button>
                </div>
            </div>
        </Fragment>
    );
};

export default AdminEditSelectChoice;
